<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { RecentPharmacySearches } from '../../utils/local-storage.ts';
  
  let {
    clearButtonTextTemplate,
    locationsTemplate,
    singleLocationTemplate,
    htmlName,
    name,
    slug,
    url,
    count,
    _tags,
    handleClearButtonClick,
    dataTestId = 'pharmacy-search-result-tile',
    focusCallback = () => {},
    blurCallback = () => {},
    parentComponent
  } = $props();

  const clearButtonTextReplacePattern = /{{PHARMACY}}/;
</script>

<div class="relative" data-testid={dataTestId}>
  <button
    onclick={() => {
      window.umami.track(`${parentComponent}-pharmacy-search-result-click`, { pharmacy: slug });
      RecentPharmacySearches.add({ name, slug, url, count, _tags });
      window.location.href = url;
    }}
    onfocus={() => focusCallback()}
    onblur={() => blurCallback()}
    class="block w-full shadow-y-sm rounded-sm bg-white text-blue-navy pseudo-shadow-tight-hover active:shadow-active"
    aria-label={name}
  >
    <div class="w-full px-3 py-2 flex justify-between align-middle">
      <div class="text-base tracking-wider" aria-hidden="true">
        {@html htmlName || name}
      </div>
      <span class="text-gray-charcoal text-sm mt-0.5" class:mr-6={handleClearButtonClick}>
        {#if count == 1 && singleLocationTemplate}
          {@html singleLocationTemplate.replace(/{{COUNT}}/, count)}
        {:else}
          {@html locationsTemplate.replace(/{{COUNT}}/, count)}
        {/if}
      </span>
    </div>
  </button>
  {#if handleClearButtonClick}
    <button
      class="absolute top-0 right-0 w-10 h-10 flex justify-center items-center text-gray-silver hover-hover:hover:text-gray-warm
      focus:text-blue-darkish focus:outline-hidden active:text-gray-warm"
      aria-label={clearButtonTextTemplate && clearButtonTextTemplate.replace(clearButtonTextReplacePattern, name)}
      data-testid="{dataTestId}-clear-button"
      onclick={() => handleClearButtonClick({ name, slug, url, count, location: _tags })}
    >
      <svg class="w-4 h-4 fill-current rounded-full" role="presentation">
        <use xlink:href="{SPRITESHEET_URL}clear-x" />
      </svg>
    </button>
  {/if}
</div>
